import React from 'react';
import { ApplicationQuestionnaireListSubcategory } from '../../api/openapi';

import QuestionnaireDetailQuestionsTable from './QuestionnaireDetailQuestionsTable';

interface Props {
  questionnaireId: string;
  categoryId: string;
  subcategory: ApplicationQuestionnaireListSubcategory;
}

const QuestionnaireDetailSubcategoryRow: React.FC<Props> = ({ questionnaireId, categoryId, subcategory }: Props) => {
  return (
    <>
      <div className="subcategoryDetailRow">
        <strong>{subcategory.name}</strong>
        <br />
        {subcategory.description}
      </div>

      <QuestionnaireDetailQuestionsTable categoryId={categoryId} subcategoryId={subcategory.id} />
    </>
  );
};

export default QuestionnaireDetailSubcategoryRow;
